import type { PlayerId } from "../../../shared/types";

interface Props {
  scores: [number, number];
  winner: PlayerId | null;
  p1Name: string;
  p2Name: string;
  onPlayAgain: () => void;
  onHome: () => void;
  onViewReplay?: () => void;
  replayBusy?: boolean;
}

export default function ResultsOverlay({ scores, winner, p1Name, p2Name, onPlayAgain, onHome, onViewReplay, replayBusy }: Props) {
  const p1Won = winner === "p1";
  const p2Won = winner === "p2";
  const tie = winner === null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
      <div className="bg-board-cell rounded-xl p-8 max-w-lg w-full mx-4 space-y-6 text-center">
        <h2 className="text-3xl font-bold text-vsw-400">
          {tie ? "It's a Tie!" : `${winner === "p1" ? p1Name : p2Name} Wins!`}
        </h2>

        <div className="grid grid-cols-2 gap-4">
          <div className={`p-4 rounded-lg ${p1Won ? "bg-vsw-500/20 ring-2 ring-vsw-400" : "bg-board-bg"}`}>
            <div className="text-vsw-200 font-medium">{p1Name}</div>
            <div className="text-3xl font-bold text-vsw-400">{scores[0]}</div>
          </div>
          <div className={`p-4 rounded-lg ${p2Won ? "bg-vsw-500/20 ring-2 ring-vsw-400" : "bg-board-bg"}`}>
            <div className="text-vsw-200 font-medium">{p2Name}</div>
            <div className="text-3xl font-bold text-vsw-400">{scores[1]}</div>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onPlayAgain}
            className="flex-1 bg-vsw-500 text-white py-3 rounded-lg font-bold hover:bg-vsw-400"
          >
            Play Again
          </button>
          {onViewReplay && (
            <button
              onClick={onViewReplay}
              disabled={replayBusy}
              className={`flex-1 py-3 rounded-lg font-bold ${replayBusy ? "bg-purple-500/40 text-white/60" : "bg-purple-500/80 text-white hover:bg-purple-500"}`}
            >
              {replayBusy ? "Preparing replay…" : "View Replay"}
            </button>
          )}
          <button
            onClick={onHome}
            className="flex-1 bg-board-border text-vsw-200 py-3 rounded-lg font-bold hover:bg-board-bg"
          >
            Home
          </button>
        </div>
      </div>
    </div>
  );
}
